import React from 'react';

import type { AiAction } from '~/components/AiChat/types';
import { isDynamicClaimActionTaskData } from '~/components/AiChat/types';
import { ConfidenceChip } from '~/components/ClaimPage/CliveApp/Confidence';

interface ActionConfidenceProps {
  action: AiAction;
}

/**
 * How sure Clive was of the action: the score, 0 to 1, it sends in the envelope's metadata. Nothing
 * where there is none — the field is optional on the wire, a legacy action never carries one, and a
 * recorded version may predate the envelope or its metadata.
 */
const ActionConfidence: React.FC<ActionConfidenceProps> = ({ action }) => {
  const confidence = isDynamicClaimActionTaskData(action.task_data)
    ? action.task_data.envelope?.metadata?.confidence
    : undefined;

  return <ConfidenceChip score={typeof confidence === 'number' ? confidence : undefined} />;
};

export default ActionConfidence;
